import { Avatar } from '@mui/material';

import { getInitials } from '@/utils/formatters';

export interface ProfileAvatarProps {
  firstName: string;
  lastName: string;
  imageUrl?: string | null;
  size?: number;
}

export function ProfileAvatar({ firstName, lastName, imageUrl, size = 40 }: ProfileAvatarProps) {
  const initials = getInitials(firstName, lastName);
  return (
    <Avatar
      src={imageUrl ?? undefined}
      alt={`${firstName} ${lastName}`}
      // FrontendGuidelines §10.4. Matters most in the candidate directory and applicant lists, which
      // render dozens of these — the ones below the fold are not fetched until scrolled to, and
      // async decoding keeps the arriving ones off the main thread. Above-the-fold instances (the top
      // bar's SessionAvatar) are unaffected: a lazy image already in the viewport loads immediately.
      slotProps={{ img: { loading: 'lazy', decoding: 'async' } }}
      sx={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {initials}
    </Avatar>
  );
}
